<template>
    <ul :class="parentDOM? 'fileList teafileList' : 'fileList'">
        <li
         v-for="(item, index) in files"
         :key="index">
            <span class="filename">{{ item.name }}</span>
            <el-dropdown
             v-if="parentDOM" 
             @command="e => commandClick(e, item, index)">
                <span class="el-dropdown-link">
                    <el-link>操作<i class="el-icon-arrow-down el-icon--right"></i></el-link>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="fileAddBoard">投屏</el-dropdown-item>
                    <el-dropdown-item command="pushFile">推送</el-dropdown-item>
                    <el-dropdown-item command="downloadFile">下载</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <i v-else @click="downloadFile(item.url)" class="el-icon-download"></i>
        </li>
    </ul>
</template>
<script>
import fileApi from '@/request/api/file.js';

export default {
    props: [
        'fileList', 
        'parentDOM', 
        'pushFile', 
        'addImageElement', 
        'addVideoFile', 
        'fileTranscode', 
        'addBoardIng', 
        'changeAddBoardStatus'
    ],
    computed: {
        files() {
            return this.fileList;
        },
    },
    methods: {
        //操作
        commandClick(e, item, index) {
            if(e == 'fileAddBoard') {
                this.fileAddBoard(item, index);
            } else if(e == 'pushFile') {
                this.$emit('pushFile', item);
            } else if(e == 'downloadFile') {
                this.downloadFile(item.url)
            }
        },
        //判断类型 追加到白板
        fileAddBoard(item, index) {
            console.log(this.addBoardIng)
            if(!this.addBoardIng) {
                console.log(item, index)
                if(item.fid) {
                    this.$emit('changeBoardTab', item.fid);
                    this.$emit('setCurrentTab', item.name);
                    return 
                }
                if(/\.(bmp|jpg|jpeg|png|gif|webp|svg|psd|ai)$/.test(item.url)) {
                    this.$emit('addImageElement', item.url);
                } else if(/\.(mp4)$/.test(item.url)) {
                    this.$emit('addVideoFile', item.url, index);
                    this.$emit('changeAddBoardStatus', true);
                    this.$emit('setCurrentTab', item.name);
                } else if(/\.(ppt|pptx|pdf|doc|docx)$/.test(item.url)) {
                    this.$message('文件开始转码');
                    this.$emit('changeAddBoardStatus', true);
                    fileApi.urlToBase64(item.url, async res => {
                        console.log(res)
                        if(res.succeed) {
                            let file =  await this.base64toFile(res.data, item.name)
                            console.log(file)
                            this.$emit('fileTranscode', file, index);
                            this.$emit('setCurrentTab', item.name);
                        }
                    })
                } else {
                    this.$message({
                        message: '暂不支持此类型文件',
                        type: 'warning'
                    });
                }
            }
        },
        //下载
        downloadFile(url) {
            this.$message({
                message: "正在下载中，请稍候"
            });
            fileApi.downLoad(url, res => {
                this.downloadFileFun(res.data, url);
            });
        },
        //转换文件流
        downloadFileFun(data, path) {
            let arr = path.split('/');
            if (!data) {
                return;
            }
            let url = window.URL.createObjectURL(new Blob([data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", arr[arr.length-1]);
            document.body.appendChild(link);
            link.click();
        },
        base64toFile(dataurl, filename) { 
            return new Promise((resolve) => {
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                resolve(new File([u8arr], filename, { type: mime }));
            })

        },
    }
}
</script>
<style scoped>
.fileList {
    width: 100%;
    height: calc(100% - 135px);
    padding: 5px;
    background-color: #F5F5F5;
    border: 1px solid var(--theme-color);
    border-radius: 3px;
    overflow-x: hidden;
    overflow-y: scroll;   
}
.teafileList {
    height: calc(100% - 100px);
}
.fileList::-webkit-scrollbar {
    width: 3px;
}
.fileList::-webkit-scrollbar-thumb {
    width: 8px;
    height: 20px;
    background: #999aaa;
    border-radius: 3px;
}
.fileList li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 5px;
    font-size: 14px;
    border-bottom: 1px solid #ccc;
}
.fileList li span.filename {
    display: inline-block;
    width: calc(100% - 60px);
    margin: 5px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.el-icon-download {
    font-size: 25px;
}
.screenIcon,
.pushIcon {
    display: inline-block;
    width: 25px;
    margin: 0 5px;
    cursor: pointer;
}
.el-icon-download {
    cursor: pointer;
}
</style>
    


// WEBPACK FOOTER //
// src/views/classroom1/components/fileList.vue